import React, { useState } from "react";
import EditIcon from "../images/edit-icon-2.png";
import { getProfileImageUrl } from "../utils/profileImage";

type Props = {
  user: any;
  onEdit(): void;
};

const EditableProfileAvatar: React.FC<Props> = ({ user, onEdit }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const imageToShow = getProfileImageUrl(user.profileUrl);

  return (
    <div className="editable-profile-avatar-wrapper">
      <img
        src={imageToShow}
        alt="profile"
        className="editable-profile-avatar-img"
        onLoad={() => setImageLoaded(true)}
      />

      {imageLoaded && (
        <div className="edit-overlay-circle" onClick={onEdit}>
          <img src={EditIcon} alt="edit" className="edit-overlay-icon" />
        </div>
      )}
    </div>
  );
};

export default EditableProfileAvatar;
